import { Reveal } from "./Reveal";
import { PROCESS } from "../../config";

export const Process = () => (
  <section id="proceso" data-testid="process" className="relative z-10 py-24 sm:py-32 bg-[var(--surface)] border-y border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline mb-3">Proceso</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.05]">
          De la llamada a la entrega
        </h2>
      </Reveal>

      <div className="mt-14 border-t border-white/10">
        {PROCESS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.05}>
            <div
              data-testid={`process-step-${p.n}`}
              className="group grid grid-cols-12 items-center gap-4 py-8 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-300 px-2 sm:px-4"
            >
              <span className="col-span-2 sm:col-span-1 font-display text-2xl sm:text-3xl font-bold text-white/15 group-hover:text-[var(--magenta)] transition-colors duration-300">
                {p.n}
              </span>
              <h3 className="col-span-10 sm:col-span-4 font-display font-semibold text-xl sm:text-2xl">
                {p.title}
              </h3>
              <p className="col-span-12 sm:col-span-7 text-zinc-400 sm:text-right">
                {p.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
